import { CompleteCompanyStaffDto } from "@inosio/payments-sdk";
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, ClassNameMap, IconButton } from "@mui/material";
import { AppDispatch } from "../../../app/store";
import { deletePmStaff } from "../sagas/accountManagementSlice";
import CancelIcon from "../../../icons/cancelIcon.svg";
import { formatStringToSentenceCase } from "../../../shared/util/formaters";

interface deleteProps {
  classes: ClassNameMap;
  openDelete: boolean;
  setOpenDelete: React.Dispatch<React.SetStateAction<boolean>>;
  currentUser: Partial<CompleteCompanyStaffDto>;
  setCurrentUser: React.Dispatch<React.SetStateAction<Partial<CompleteCompanyStaffDto>>>;
  defaultUser: Partial<CompleteCompanyStaffDto>;
  dispatch: AppDispatch;
}

export default function DeleteDialog(props: deleteProps) {
  return (
    <Dialog
      open={props.openDelete}
      onClose={(e, reason) => {
        props.setCurrentUser(props.defaultUser);
        props.setOpenDelete(false);
      }}
      classes={{ paper: props.classes.dialogPaper }}
      className={props.classes.deleteDialog}
      id="deleteDialog"
      PaperProps={{
        style: { borderRadius: 24 },
      }}
    >
      <DialogTitle sx={{ alignSelf: "center", fontSize: 16, pt: "27px", justifyContent: "flex-end", width: "100%", display: "flex", "& p": { mt: 0, mb: 0 } }}>
        <p>Confirm Remove</p>
        <IconButton
          sx={{ marginLeft: "140px", p: 0 }}
          onClick={() => {
            props.setCurrentUser(props.defaultUser);
            props.setOpenDelete(false);
          }}
        >
          <img src={CancelIcon} alt="cancel icon" width="26px" height="26px" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ "& .MuiTypography-body1": { fontWeight: 400 }, "& .MuiTypography-body1:first-of-type": { fontWeight: 800 } }}>
        <DialogContentText>{`${formatStringToSentenceCase(props.currentUser.FirstName as string)} ${formatStringToSentenceCase(props.currentUser.LastName as string)}`}</DialogContentText>
        <DialogContentText>You are about to remove this user, it will not be possible to re-instate this user when completed. They will not be notified and their access will be revoked immediately. If they are logged in, they will not be able to complete any actions, but could still view data on the page they are viewing.</DialogContentText>
        <DialogContentText>Are you sure you want to proceed?</DialogContentText>
      </DialogContent>
      <DialogActions className={props.classes.dialogActionButtons}>
        <Button
          onClick={() => {
            props.setCurrentUser(props.defaultUser); // reset state
            props.setOpenDelete(false);
          }}
          variant="contained"
        >
          No
        </Button>
        <Button
          onClick={() => {
            props.dispatch(deletePmStaff({ uuid: props.currentUser.Uuid }));
            props.setCurrentUser(props.defaultUser);
            props.setOpenDelete(false);
          }}
          variant="contained"
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
